// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__hXjK7","col":"styles_col__BuEWI"};